var exports = {
  "uz": "CustomerStory__POG-Hl",
  "bq": "CustomerStory__logo__AHAvXK",
  "AK": "CustomerStory__logo--flatColour__ObXlCF",
};

module.exports = exports;
